import React from "react";
import { Box } from "@mui/material";
import { RobotoTypo, TimesNewTypo } from "../../../utils/Typographies";
import { useTranslation } from "react-i18next";
import CompanyRegistrationImage from "../../../assets/ServicesImages/CompanyRegistrationImages/header.png";
import { useStyles } from "../../../utils/headerTheme";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

export default function CompanyRegistrationHeader1() {
  const path = useLocation()
  console.log("path ", path);
    const language = useSelector((state) => state.language.language); 
  const { t } = useTranslation();
  const classes = useStyles();
const baseKey = path.pathname
  const formatPathname = (path) => {
  return path
    .replace("/", "")                // remove leading slash
    .replace(/-/g, " ")              // replace hyphens with spaces
    .replace(/\b\w/g, (c) => c.toUpperCase()); // capitalize each word
};

  return (
    <Box
      sx={{
        position: "relative",
        // height: '100%',
        width: "100%",
        overflow: "hidden",
        background: "#B1D0E0",
      }}
    >
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: {
            xs: "column",
            md: "column",
            lg: "row",
            xl: "row",
            xxl: "row",
          },
          justifyContent: "end",
        }}
      >
        <Box
          sx={{
            background: "#fff",
            borderBottomRightRadius: { md: "0", lg: "50px" },
            padding: { xs: "0", md: "0", lg: "60px 80px" },
            zIndex: { xs: 0, md: 0, lg: 10 },
            height: { xs: "100px", md: "100px", lg: "60px", xl: "60" },
            // width: { xs: '100%', md: '100%', lg: '15%', xl: '15%' },
            position: {
              xs: "relative",
              md: "relative",
              lg: "absolute",
              xl: "absolute",
            },
            left: "0",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 1,
              fontSize: "16px",
            }}
          >
            <RobotoTypo
              sx={{
                textAlign: { xs: "center", sm: "left" },
                letterSpacing: "0.03em",
                fontWeight: "500",
                color: "#003B5C",
                fontSize: { xs: "20px", sm: "25px", md: "28px", lg: "30px" },
              }}
            >
              {t(`${baseKey}.title`, {returnObjects : true})}
            </RobotoTypo>
            <TimesNewTypo
              sx={{
                textAlign: { xs: "center", sm: "left" },
                letterSpacing: "0.025em",
                fontWeight: "700",
                color: "#177D84",
                fontSize: { xs: "18px", md: "24px", lg: "25px" },
              }}
            >
              {
                t("service.HrRecruitment.CompanyRegistrationHeader", {
                  returnObjects: true,
                }).name2
              }
            </TimesNewTypo>
          </Box>
        </Box>

        <Box
          sx={{
            width: "100%", // Full width for all screen sizes
            maxWidth: { lg: "85%", xl: "85%", xxl: "85%" }, // Apply 85% width only for larger screens
            position: "relative",
            zIndex: 1,
            borderBottomLeftRadius: {
              xs: "0px",
              md: "0px",
              lg: "0px",
              xl: "50px",
              xxl: "50px",
            },
            height: { xs: "auto", md: "calc(80vh - 128px)" }, // Auto height for mobile, calculated height for others
            marginBottom: { xs: "16px", lg: "30px" }, // Add spacing at the bottom for mobile
            overflow: "hidden", // Prevent image overflow
          }}
        >
          <img
            className={classes.headerImage}
            src={CompanyRegistrationImage}
            alt="CompanyRegistration"
            style={{
              objectFit: "cover",
              height: "100%",
              borderBottomLeftRadius: {
                xs: "0",
                md: "0",
                lg: "0",
                xl: "50px",
                xxl: "50px",
              },
              width: "100%",
              position: {
                xs: "relative",
                md: "relative",
                lg: "absolute",
                xl: "absolute",
                xxl: "absoulte",
              },
              right: "0",
            }}
          />
        </Box>
      </Box>
      <Box
        sx={{
          height: "200px",
          display: {
            xs: "none",
            md: "none",
            lg: "block",
            xl: "block",
            xxl: "block",
          },
          width: { xs: "15%", sm: "15%", md: "12%", lg: "10%", xl: "10%" },
          borderTopRightRadius: "50px",
          borderRight: "8px solid white",
          borderTop: "8px solid white",
          borderColor: "#F5DFBA",
          position: "absolute",
          bottom: "0px",
          zIndex: "99",
        }}
      ></Box>
    </Box>
  );
}
